import React from "react";

function YieldReportTable(props) {
  const { data } = props;

  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper yield-wrapper">
        <table className="table last-column">
          <thead>
            <tr className="">
              <th scope="col">PARTY CODE</th>
              <th scope="col">GROSS BROKERAGE CASH</th>
              <th scope="col">CASH BROKERAGE REVERSAL</th>
              <th scope="col">NET BROKERAGE CASH</th>
              <th scope="col">GROSS BROKERAGE FNO</th>
              <th scope="col">FNO BROKERAGE REVERSAL</th>
              <th scope="col"> NET BROKERAGE FO</th>
              <th scope="col">TOTAL GROSS BROKERAGE</th>
              <th scope="col">TOTAL NET BROKERAGE</th>
              <th scope="col">MARGIN UTILISATION FNO</th>
              <th scope="col">MARGIN UTILISATION CASH</th>
              <th scope="col">TOTAL MARGIN UTILISATION</th>
              <th scope="col">LEDGER BALALNCE</th>
              <th scope="col">LIQUID FUND</th>
              <th scope="col">FIXED DEPOSIT</th>
              <th scope="col">STOCK PLEDGE</th>
              <th scope="col">CASHFUND UTLBFSL</th>
              <th scope="col">FNOFUND UTLBFSL</th>
              <th scope="col">TOTFUND UTLBFSL</th>
              <th scope="col">CASH YIELD</th>
              <th scope="col">FNO YIELD</th>
              <th scope="col">TOTYIEL</th>
            </tr>
          </thead>

          <tbody>
            {data &&
              data?.map((item, key) => {
                return (
                  <>
                    <tr key={key}>
                      <td>{item?.partyCode || "-"}</td>
                      <td>{item?.grossBrokerageCash || 0}</td>
                      <td>{item?.cashBrokerageReversal || 0}</td>
                      <td>{item?.netBrokerageCash || 0}</td>
                      <td>{item?.grossBrokerageFno || 0}</td>
                      <td>{item?.fnoBrokerageReversal || 0}</td>
                      <td>{item?.netBrokerageFo || 0}</td>
                      <td>{item?.totalgrossBrokerage || 0}</td>
                      <td>{item?.totalNetBrokerage || 0}</td>
                      <td>{item?.marginUtilisationFno || 0}</td>
                      <td>{item?.marginUtilisationCash || 0}</td>
                      <td>{item?.totalMarginUtilisation || 0}</td>
                      <td>{item?.ledgerBalalnce || 0}</td>
                      <td>{item?.liquidFund || 0}</td>
                      <td>{item?.fixedDeposit || 0}</td>
                      <td>{item?.stockPledge || 0}</td>
                      <td>{item?.cashfundUtlbfsl || 0}</td>
                      <td>{item?.fnofundUtlbfsl || 0}</td>
                      <td>{item?.totfundUtlbfsl || 0}</td>
                      <td>{item?.cashYield || 0}</td>
                      <td>{item?.fnoYield || 0}</td>
                      <td>{item?.totYield || 0}</td>
                    </tr>
                  </>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
}
export default YieldReportTable;
